module.exports = __webpack_public_path__ + "main/assets/public/special-mode/radiothon-2018/background.c199e40db764f605.png";